import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
    // i18n handles localStorage caching via detection.caches setting
  };

  // Get base language code (handles 'da-DK' → 'da')
  const currentLang = i18n.language?.substring(0, 2) || 'da';

  return (
    <select
      value={currentLang}
      onChange={(e) => changeLanguage(e.target.value)}
      className="text-gray-700 bg-transparent hover:bg-gray-100 px-2 py-2 rounded text-sm cursor-pointer border-none focus:ring-0 focus:outline-none"
      aria-label={t('label.selectLanguage')}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.flag} {lang.name}
        </option>
      ))}
    </select>
  );
}

export default LanguageSwitcher;
